import React, { useRef, useState, useEffect } from "react";
import { Box } from "@mui/system";
import css from "./header.module.css";
import { NavLink } from "react-router-dom";
import {
  Menu,
  Close,
  ArrowDropDown,
  Pageview,
  Add,
} from "@mui/icons-material/";
import DropLink from "./DropLink";
import {
  homeDropLink,
  homeDropSecondLink,
  pagesDropDownLinks1,
  pagesDropDownLinks2,
} from "./navbardata";
import resources from "../../resources/index";
const Navbar = ({ isScrolled }) => {
  //Its is for the mobile screen. It remain false untill
  //we click on the "Menu" icon(show only under 500px)
  const [toggle, setToggle] = useState(false);

  //we are using dropdownRef to handle is the user anywhere else on
  //the screen, the dropdown shoul close
  const dropdownRef = useRef();
  const [isHomeDropdownOpen, setIsHomeDropdownOpen] = useState(false);
  const [isPagesDropdownOpen, setIsPagesDropdownOpen] = useState(false);

  const homeClickHandle = () => {
    setIsPagesDropdownOpen(false);
    setIsHomeDropdownOpen(!isHomeDropdownOpen);
    // setToggle(false);
  };
  const pagesClickHandle = () => {
    setIsHomeDropdownOpen(false);
    setIsPagesDropdownOpen(!isPagesDropdownOpen);

    // setToggle(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsHomeDropdownOpen(false);
      setIsPagesDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  return (
    <Box ref={dropdownRef}>
      <Box className={toggle ? `${css.active}` : ""}>
        {/* for small screens only */}
        <div className={`${css.mobile_navbar_btn}`}>
          <Menu
            name="menu-outline"
            className={`${css.mobile_nav_icon}`}
            onClick={() => setToggle(true)}
          />
          <div className={css.close_outline_div}>
            <img src={resources.icons.logo_scrolled} alt="Logo" />
            <button className={css.close_outline_btn}>
              <Close
                name="close-outline"
                className={`${css.mobile_nav_icon} ${css.close_outline}`}
                onClick={() => {
                  setIsHomeDropdownOpen(false);
                  setIsPagesDropdownOpen(false);
                  setToggle(false);
                }}
              />
            </button>
          </div>
        </div>
        <ul
          className={`${css.navbar_lists}  ${
            isScrolled ? css.scrolled_nav : ""
          }`}
        >
          <li>
            <NavLink
              onClick={() => homeClickHandle()}
              className={`${css.navbar_link} ${css.drop_down_container}`}
            >
              <div className={css.home_dropdown}>
                <p>Home</p>
                <span className={css.home_dropdown_drop}>
                  <ArrowDropDown />
                </span>
                <span className={css.home_dropdown_plus}>
                  <Add />
                </span>
              </div>
              {isHomeDropdownOpen && (
                <div className={css.dropdownWrapper}>
                  <ul className={`${css.dropdown} ${css.div1}`}>
                    <h4
                      style={{
                        color: "black",
                        fontSize: "1.2rem",
                        marginLeft: "1.5rem",
                      }}
                    >
                      Different Homes
                    </h4>
                    {homeDropLink.map((currentLink) => {
                      return (
                        <DropLink
                          key={currentLink.id}
                          currentLink={currentLink}
                        />
                      );
                    })}
                  </ul>
                  <div className={css.stylish_box}></div>
                  <ul className={`${css.dropdown} ${css.div2}`}>
                    {homeDropSecondLink.map((currentLink) => {
                      return (
                        <DropLink
                          key={currentLink.id}
                          currentLink={currentLink}
                        />
                      );
                    })}
                  </ul>
                </div>
              )}
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/services"
              onClick={() => setToggle(false)}
              className={`${css.navbar_link}`}
            >
              Services
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              onClick={() => setToggle(false)}
              className={`${css.navbar_link}`}
            >
              About
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/pricing"
              onClick={() => setToggle(false)}
              className={`${css.navbar_link}`}
            >
              Pricing
            </NavLink>
          </li>

          <li>
            <NavLink
              onClick={() => pagesClickHandle()}
              className={`${css.navbar_link} ${css.drop_down_container}`}
            >
              <div style={{ marginTop: "0.5rem" }} className={css.home_dropdown}>
                <p>Pages</p>
                <span className={css.home_dropdown_drop}>
                  <ArrowDropDown />
                </span>
                <span className={css.home_dropdown_plus}>
                  <Add />
                </span>
              </div>
              {isPagesDropdownOpen && (
                <div className={css.dropdownWrapper}>
                  <ul className={`${css.dropdown} ${css.div1}`}>
                    <h4
                      style={{
                        color: "black",
                        fontSize: "1.2rem",
                        marginLeft: "1.5rem",
                      }}
                    >
                      Useful Links
                    </h4>
                    {pagesDropDownLinks1.map((currentLink) => {
                      return (
                        <DropLink
                          key={currentLink.id}
                          currentLink={currentLink}
                          page={true}
                        />
                      );
                    })}
                  </ul>
                  <div className={css.stylish_box}></div>
                  <ul className={`${css.dropdown} ${css.div2}`}>
                    <h4
                      style={{
                        color: "black",
                        fontSize: "1.2rem",
                        marginLeft: "1.5rem",
                      }}
                    >
                      Utility Pages
                    </h4>
                    {pagesDropDownLinks2.map((currentLink) => {
                      return (
                        <DropLink
                          key={currentLink.id}
                          currentLink={currentLink}
                          page={true}
                        />
                      );
                    })}
                  </ul>
                </div>
              )}
            </NavLink>
          </li>
          <div className={css.header_btn}>
            <button
              className={`${css.signIn} ${
                isScrolled ? css.scrolled_signIn : ""
              }`}
            >
              Sing In
            </button>
            <button className={css.getStarted}>Get Started</button>
          </div>
        </ul>
      </Box>
    </Box>
  );
};

export default Navbar;
